import React from 'react';
import { Form, Input, Button, Card, Col, Row } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import ContactTitle from './ContactTitle';

import emailjs from 'emailjs-com';

const Contact = () => {
    const onFinish = (values) => {
        console.log(values);
        emailjs.sendForm('service_n2ste59', 'template_agtnpcp', values, 'user_HbygetjhjyQbdjNrPApQJ')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div>
           
            <ContactTitle />

            <Row justify="center" align="middle" style={{ height: '70vh' }}>
                <Col xs={24} sm={24} md={14} lg={12} xl={8} xxl={6} >
                    <Card>
                        <Form initialValues={{ remember: true, }} onFinish={onFinish}  >

                            <Form.Item name="name" rules={[{ required: true, message: 'Please input your Name!', },]} >
                                <Input prefix={<UserOutlined />} placeholder="Name" />
                            </Form.Item>

                            <Form.Item name="username" rules={[{ required: true, message: 'Please input your Username!', },]} >
                                <Input prefix={<UserOutlined />} placeholder="Username" />
                            </Form.Item>

                            <Form.Item name="description" rules={[{ required: true, message: 'Please input your Description!', },]}>
                                <TextArea rows={4} placeholder="Description" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" ghost block >Submit</Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>



            
        </div>
    );
};

export default Contact;